import { Variant, Variants } from "@amplitude/experiment-js-client";

export enum FeatureFlag {
  NewLinks = "newlinks",
  NewSearchResult = "newsearchresult",
}

export const FeatureFlags: Variants = {
  [FeatureFlag.NewLinks]: {
    key: "default",
    value: "default",
    expKey: FeatureFlag.NewLinks,
    payload: {
      links: ["main", "search", "catchall"],
    },
  },
  [FeatureFlag.NewSearchResult]: {
    key: "default",
    value: "default",
    expKey: FeatureFlag.NewSearchResult,
    payload: {},
  },
};
